import { render, staticRenderFns } from "./BaseListBlock.vue?vue&type=template&id=0e2c9746&"
import script from "./BaseListBlock.vue?vue&type=script&lang=js&"
export * from "./BaseListBlock.vue?vue&type=script&lang=js&"
import style0 from "./BaseListBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports